import { connect } from 'react-redux';
import { dispatchify, recall } from 'common/utils/utils';
import {
  shouldStopGetReposRecall,
  shouldStopOnboardingRecall
} from 'common/services/http-polling-stopper';
import {
  isFinishedOnBoardingSelector,
  getLastOnPremisesHeartbeatSelector
} from 'state/selectors/organization';
import { isTeamLicenseSelector } from 'state/selectors/license';
import {
  getAccountByToken,
  getConfiguration,
  getRepositories,
  createRepositories,
  createOrganization,
  getContributors,
  getSensorAuthorizations,
  getDefaultIterations,
  DateSelectionChanged,
  updateSensorAuthorization,
  deleteSensorAuthorization,
  toggleSnackBar,
  setDefaultBoard,
  changeDefaultBoard,
  getBoards,
  getJobsDetails,
  getProjects,
  toggleModal,
  getServices,
  getIterations
} from 'state/callers';
import { currentIterationSelector } from 'state/selectors/iterations-picker';
import {
  getAllSettingsSucceed,
  routeChanged,
  selectTeamId,
  setIsProcessingRepos
} from 'state/actions';
import { myAccountSelector } from 'state/selectors/account';
import { getTeams } from 'state/callers/teams';
import {
  isProjectManagementConnectedSelector,
  isSlackConnectedSelector,
  getFailingSensorAuthorizationWithoutAzureAndClubhouse
} from 'state/selectors/sensors-authorizations';
import { selectedTeamProject } from 'state/selectors/projects';
import Home from './Home';
import { JOB_NAMES } from 'common/services/jobs-suites.service';
import {
  reposProcessPercentageSelector,
  isSyncContributorsJobFinishedSelector
} from 'state/selectors/jobs';
import { isProcessingReposSelector } from 'state/selectors/ui-state';
import { contributorsSelector } from 'state/selectors/contributors';
import { repositoriesSelector } from 'state/selectors/repositories';
import withPMData from 'components/HOC/PmHOC/withPMData';
import { customBoardSelector } from 'state/selectors/boards';

const mapStateToProps = state => {
  const {
    uiState,
    configuration,
    organization,
    sensorAuthorizations,
    iterations,
    boards,
    currentTeams
  } = state;

  return {
    account: myAccountSelector(state),
    repositories: repositoriesSelector(state),
    uiState,
    configuration,
    organization,
    sensorAuthorizations,
    iterations,
    isFinishedOnBoarding: isFinishedOnBoardingSelector(state),
    currentIteration: currentIterationSelector(state),
    isTeamLicense: isTeamLicenseSelector(state),
    boards,
    currentTeams,
    contributors: contributorsSelector(state),
    isSyncContributorsCompleted: isSyncContributorsJobFinishedSelector(state),
    isProjectManagementConnected: isProjectManagementConnectedSelector(state),
    reposProcessedPercentage: reposProcessPercentageSelector(state),
    isProcessingRepos: isProcessingReposSelector(state),
    selectedTeamContainers: selectedTeamProject(state),
    selectedTeamProject: selectedTeamProject(state),
    isSlackConnected: isSlackConnectedSelector(state),
    failingSensorsAuthorizations:
      getFailingSensorAuthorizationWithoutAzureAndClubhouse(state),
    customBoard: customBoardSelector(state),
    lastOnPremisesHeartbeat: getLastOnPremisesHeartbeatSelector(state)
  };
};

const mapDispatchToProps = dispatch => {
  return {
    ...dispatchify(dispatch, {
      getAccountByToken,
      getConfiguration,
      getRepositories,
      createRepositories,
      createOrganization,
      getContributors,
      getProjects,
      getSensorAuthorizations,
      getDefaultIterations,
      getIterations,
      DateSelectionChanged,
      routeChanged,
      updateSensorAuthorization,
      deleteSensorAuthorization,
      toggleSnackBar,
      getTeams,
      setDefaultBoard,
      changeDefaultBoard,
      getBoards,
      selectTeamId,
      setIsProcessingRepos,
      toggleModal,
      getServices,
      getAllSettingsSucceed
    }),
    ...recall(
      {
        ...dispatchify(dispatch, {
          getOnboardingJob: () => getJobsDetails(JOB_NAMES.ONBOARDING)
        })
      },
      shouldStopOnboardingRecall,
      20
    ),
    ...recall(
      {
        ...dispatchify(dispatch, {
          // eslint-disable-next-line jsdoc/require-jsdoc
          getRepositories: () => getRepositories()
        })
      },
      shouldStopGetReposRecall,
      60
    )
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(withPMData(Home));
